
$(document).ready(function() {
  // Get all elements with the class "availsize"
  var availsizeElements = $('.availsize');

  availsizeElements.each(function(index, availsize) {
    // Get all the p tags inside the current availsize element
    var sizes = $(availsize).find('p');

    // Check if any p tag contains the text "Default Title"
    var containsDefaultTitle = Array.isArray(sizes) && sizes.some(function(index, size) {
      return $.trim($(size).text()) === "Default Title";
    });

    // If "Default Title" is found, add the "hidden" class to the current availsize element
    if (containsDefaultTitle) {
      $(availsize).addClass('hidden');
    }

    // Create an array to store the sizes
    var sizeArray = [];

    // Iterate through each p tag and add its text content to the sizeArray
    sizes.each(function(index, size) {
      sizeArray.push($.trim($(size).text()));
    });

    // Convert the sizeArray to a comma-separated string
    var sizeString = sizeArray.join(', ');

    // Set the text content of the availsize element to the comma-separated sizes
    $(availsize).text("Available Sizes: " + sizeString);
  });
});